export const WORDS = [
  'mayto',
  'petra',
  'alien',
  'kaos',
  'santa',
  'alice',
  'malum',
  'kemet',
  'level',
  'hollywood',
  'avengadores',
  'unreal',
  'albus',
  'valhalla',
  'troya',
  'olimpo',
  'abduction',
  'tao',
  'sabotaje',
  'cybercity',
  'mythos',
  'naturia',
  'megachef',
  'influx',
  'synergo',
  'cronosfera',
  'futura',
  'mina',
  'experiencity',
  'cronos',
  'enigmik',
  'wozniack',
  'invernadero',
  'logia',
  'sastre',
  'alcatraz',
  'entrevista',
  'toilet',
  'iniciativa',
  'cain',
  'videoclub',
  'akasha',
  'catacumbas',
  'pelicula',
  'cubick',
  'elements',
  'dragonborn',
  'distrito',
  'nathael',
  'ingenious',
  'arcanum',
  'insidious',
  'paranormal',
  'xkapa',
  'yucatan',
  'worm',
  'hangar',
  'castlemaniacs',
  'hipolita',
  'transporter',
  'dino',
  'mazmorra',
  'bosque',
  'gladiador',
  'apophis',
  'sahara',
  'escapology',
  'ambar',

  'crupier',
  'nevera',
  'sapiens',
  'jigsaw',
  'evermore',
  'novia',
  'suffering',
  'ouija',
  'locktopus',
  'cluehunter',
  'pesadilla',
  'hoppit',
  'velatoria',
  'intringulis',
  'balamku',
  'hotelhello',
  'horrorbox',
  'cronologic',
  'conklave',
  'marianne',
  'locutorio',
  'lastshow',
  'komnata',
  'bitesmotel',
  'tangram',
  'finalcode',
  'thecity',
  'jollyrogers',
  'posesion',
  'cetrodefuego',
  'catalepsia',
  'escapemotel',
  'laorden',
  'horrorclub',

  'vacaciones',
  'foxinabox',
  'protagonist',
  'luzverde',
  'blasphemia',
  'sulaco',
  'ilusium',
  'insolito',
  'roomangie',
  'cocoroom',
  'rombocode',
  'yaebi',
  'inframundo',
  'vortex',
  'goldenpop',
  'darkest',
  'kenopsia',
  'endurance',
  'callordie',
  'riverblood',
  'scumisland',

  'whitechapel',
  'silenttown',
  'tempo',
  'anticuario',
  'madmansion',
  'skproom',
  'portroyal',
  'taproom',
  'sharelock',
  'reinaroja',
  'agrabah',
  'ravenbox',
  'encrypt',
  'radio',
  'canfarigola',
  'crisys',
  'thecode',
  'theexit',
  'scavenger',
  'descifra',

  // Escapistas
  'achuwoky',
  'unamzafer',
  'pescapistas',
  'loschochoni',
  'quintoelemento',
  'lokos',
  'diehelden',
  'segurqueteescapas',
  'plasticrobot',
  'gatomantes',
  'roomeliers',
  'escalinatas',
  'roomadictos',
  'escaperoomlife',
  'riddlebeaters',
  'sinroombo',
  'lafugadepiticli',
  'buscadoresdeakra',
  'escapethegate',
  'rompereglas',
  'scarymoli',
  'losdesconocidos',
  'gibaescape',
  'almainsecta',
  'thedescapers',
  'losdelamaleta',
  'hermandaddeelda',
 
  'anaysuinvitado',
  'flipetis',
  'losgorgor',
  'sweetescape',
  'familyskp',
  'yuandmay',
  'thecovenant'

  
]


             